"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SvgIconsMap = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var SvgIconsMap = exports.SvgIconsMap = {
  accessTime: /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
  }),
  accessTimeSolid: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
  }),
  accountCircle: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
  }),
  add: /*#__PURE__*/React.createElement("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
  }),
  addAttachment: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  })),
  addCircle: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
  }),
  addPhoto: /*#__PURE__*/React.createElement("path", {
    d: "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
  }),
  addToHomeScreen: /*#__PURE__*/React.createElement("path", {
    d: "M18 1.01L8 1c-1.1 0-2 .9-2 2v3h2V5h10v14H8v-1H6v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM10 15h2V8H5v2h3.59L3 15.59 4.41 17 10 11.41V15z"
  }),
  apps: /*#__PURE__*/React.createElement("path", {
    d: "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
  }),
  arrowBack: /*#__PURE__*/React.createElement("path", {
    d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
  }),
  arrowDown: /*#__PURE__*/React.createElement("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
  }),
  arrowUp: /*#__PURE__*/React.createElement("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
  }),
  arrowDropDown: /*#__PURE__*/React.createElement("path", {
    d: "M7 10l5 5 5-5z"
  }),
  arrowDropUp: /*#__PURE__*/React.createElement("path", {
    d: "M7 14l5-5 5 5z"
  }),
  arrowForward: /*#__PURE__*/React.createElement("path", {
    d: "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
  }),
  arrowRightBoldCirle: /*#__PURE__*/React.createElement("path", {
    d: "M2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12M17,12L12,7V10H8V14H12V17L17,12Z"
  }),
  assessment: /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
  }),
  attachedImage: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
  })),
  build: /*#__PURE__*/React.createElement("path", {
    d: "M17.875 20.375q-.5 0-.95-.187-.45-.188-.825-.563l-5-5.025q-.5.2-1.012.3Q9.575 15 9 15q-2.5 0-4.25-1.75T3 9q0-.9.25-1.713.25-.812.7-1.537L7.6 9.4l1.8-1.8-3.65-3.65q.725-.45 1.537-.7Q8.1 3 9 3q2.5 0 4.25 1.75T15 9q0 .575-.1 1.087-.1.513-.3 1.013l5.05 5q.375.375.563.825.187.45.187.95 0 .5-.2.962-.2.463-.55.813-.375.375-.825.55-.45.175-.95.175Z"
  }),
  calendarEvent: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })),
  cam2Cam: /*#__PURE__*/React.createElement("path", {
    d: "M17.56 10.37L22 6v12l-4.44-4.33v3.79a1.1 1.1 0 0 1-1.11 1.08H3.11A1.1 1.1 0 0 1 2 17.42V6.58A1.1 1.1 0 0 1 3.11 5.5h13.33a1.1 1.1 0 0 1 1.11 1.08zm-3.33 2.71v-2.16h-3.34V7.67H8.67v3.25H5.33v2.17h3.34v3.25h2.22v-3.26z"
  }),
  cameraSwitch: /*#__PURE__*/React.createElement("path", {
    d: "M21.6,2.33 L17.76,2.33 L15.6,0 L8.4,0 L6.24,2.33 L2.4,2.33 C1.08,2.33 0,3.38 0,4.67 L0,18.67 C0,19.95 1.08,21 2.4,21 L21.6,21 C22.92,21 24,19.95 24,18.67 L24,4.67 C24,3.38 22.92,2.33 21.6,2.33 L21.6,2.33 Z M12.03,15.34 C14.24,15.34 15.95,13.66 15.95,11.5 L13.87,11.5 L16.93,8.5 L20,11.5 L18.16,11.5 C18.16,14.86 15.46,17.5 12.03,17.5 C9.57,17.5 7.48,16.14 6.5,14.13 C7.12,14.13 9.58,14.13 9.14,14.13 C9.85,14.88 10.87,15.34 12.03,15.34 Z M11.47,6.66 C9.26,6.66 7.55,8.34 7.55,10.5 L9.63,10.5 L6.57,13.5 L3.5,10.5 L5.34,10.5 C5.34,7.14 8.04,4.5 11.47,4.5 C13.93,4.5 16.02,5.86 17,7.87 C16.38,7.87 13.92,7.87 14.36,7.87 C13.65,7.12 12.63,6.66 11.47,6.66 Z"
  }),
  campaign: /*#__PURE__*/React.createElement("path", {
    d: "M18 13V11H22V13H18ZM19.2 20L16 17.6L17.2 16L20.4 18.4L19.2 20ZM17.2 8L16 6.4L19.2 4L20.4 5.6L17.2 8ZM5 19V15H4C3.45 15 2.97917 14.8042 2.5875 14.4125C2.19583 14.0208 2 13.55 2 13V11C2 10.45 2.19583 9.97917 2.5875 9.5875C2.97917 9.19583 3.45 9 4 9H8L13 6V18L8 15H7V19H5ZM14 15.35V8.65C14.45 9.05 14.8125 9.5375 15.0875 10.1125C15.3625 10.6875 15.5 11.3167 15.5 12C15.5 12.6833 15.3625 13.3125 15.0875 13.8875C14.8125 14.4625 14.45 14.95 14 15.35Z"
  }),
  cancel: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
  }),
  chatBubble: /*#__PURE__*/React.createElement("path", {
    d: "m2.7,21.11l1.59-4.95c-.88-1.68-1.24-3.53-.97-5.48.35-2.3,1.59-4.42,3.44-5.83,1.85-1.41,4.24-2.03,6.54-1.68,4.77.71,8.13,5.12,7.42,9.98h0c-.35,2.3-1.59,4.33-3.44,5.74s-3.95,2.03-6.25,1.68c-.88-.18-1.84-.54-2.19-.71,0,.09-6.13,1.24-6.13,1.24Z"
  }),
  chatBubbleOutlined: /*#__PURE__*/React.createElement("path", {
    d: "m2.7,21.11l1.59-4.95c-.88-1.68-1.24-3.53-.97-5.48.35-2.3,1.59-4.42,3.44-5.83,1.85-1.41,4.24-2.03,6.54-1.68,4.77.71,8.13,5.12,7.42,9.98h0c-.35,2.3-1.59,4.33-3.44,5.74s-3.95,2.03-6.25,1.68c-.88-.18-1.84-.54-2.19-.71,0,.09-6.13,1.24-6.13,1.24Zm6.48-3.17l.26.09s1.02.52,1.88.7c1.81.26,3.32-.17,4.78-1.29s2.41-2.67,2.67-4.47h0c.52-3.7-2.06-7.14-5.76-7.74-1.81-.26-3.61.17-5.07,1.29s-2.41,2.67-2.67,4.47c-.17,1.55.09,3.09.86,4.47l.26.43-.86,2.84,3.65-.78h0Z"
  }),
  check: /*#__PURE__*/React.createElement("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
  }),
  checkbox: /*#__PURE__*/React.createElement("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }),
  checkboxOutlineBlank: /*#__PURE__*/React.createElement("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
  }),
  checkCircle: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
  }),
  chevronLeft: /*#__PURE__*/React.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
  }),
  chevronRight: /*#__PURE__*/React.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
  }),
  chromeReader: /*#__PURE__*/React.createElement("path", {
    d: "M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"
  }),
  circleBackslash: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
  }),
  close: /*#__PURE__*/React.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
  }),
  code: /*#__PURE__*/React.createElement("path", {
    d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
  }),
  colorize: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
  })),
  contentCopy: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
  })),
  creditCard: /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
  }),
  creditCardFail: /*#__PURE__*/React.createElement("path", {
    d: "m13.4 18 .1-.9H3v-5.7h16.6v1c.8 0 1.5 0 2.1.3v-7c0-1-1-1.9-2-1.9H3c-1.1 0-2 .8-2 1.9v11.4c0 1 .9 1.9 2 1.9h10.5v-1ZM3 5.8h16.6v1.9H3V5.7ZM23.3 16l-2.2 2 2.2 2-1.5 1.4-2.2-2-2.2 2-1.4-1.3 2.2-2-2.2-2 1.4-1.4 2.2 2 2.2-2 1.5 1.3Z"
  }),
  crown: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3.233,16.263c-0.053,0 -0.1,-0.037 -0.114,-0.089l-1.74,-6.883l4.999,2.857c0.1,0.057 0.226,0.034 0.299,-0.055l5.277,-6.461l5.278,6.461c0.073,0.089 0.199,0.112 0.298,0.055l4.999,-2.857l-1.74,6.883c-0.013,0.052 -0.06,0.089 -0.114,0.089l-8.721,0l-8.721,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "11.954",
    cy: "5.169",
    rx: "1.379",
    ry: "1.387"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "1.379",
    cy: "8.867",
    rx: "1.379",
    ry: "1.387"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "22.529",
    cy: "8.867",
    rx: "1.379",
    ry: "1.387"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.69,17.637c0,-0.248 -0.201,-0.45 -0.45,-0.45l-16.572,0c-0.248,0 -0.45,0.202 -0.45,0.45l0,1.874c0,0.248 0.202,0.45 0.45,0.45l16.572,0c0.249,0 0.45,-0.202 0.45,-0.45l0,-1.874Z"
  })),
  dateRange: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })),
  delete: /*#__PURE__*/React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
  }),
  deleteForever: /*#__PURE__*/React.createElement("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
  }),
  deviceDesktop: /*#__PURE__*/React.createElement("path", {
    d: "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
  }),
  deviceOther: /*#__PURE__*/React.createElement("path", {
    d: "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
  }),
  deviceTablet: /*#__PURE__*/React.createElement("path", {
    d: "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
  }),
  discount: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.79,21L3,11.21v2c0,0.53,0.21,1.04,0.59,1.41l7.79,7.79c0.78,0.78,2.05,0.78,2.83,0l6.21-6.21 c0.78-0.78,0.78-2.05,0-2.83L12.79,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.38,17.41c0.78,0.78,2.05,0.78,2.83,0l6.21-6.21c0.78-0.78,0.78-2.05,0-2.83l-7.79-7.79C12.25,0.21,11.74,0,11.21,0H5 C3.9,0,3,0.9,3,2v6.21c0,0.53,0.21,1.04,0.59,1.41L11.38,17.41z M7.25,3C7.94,3,8.5,3.56,8.5,4.25S7.94,5.5,7.25,5.5 S6,4.94,6,4.25S6.56,3,7.25,3z"
  })),
  dollar: /*#__PURE__*/React.createElement("path", {
    d: "M11.29 17.52h1.38v-.99c.66-.12 1.22-.37 1.7-.77s.71-.98.71-1.75c0-.55-.16-1.06-.47-1.52s-.95-.86-1.89-1.2c-.79-.26-1.33-.49-1.64-.69s-.45-.47-.45-.81.12-.61.36-.81.59-.3 1.05-.3c.42 0 .75.1.99.31s.41.46.51.76l1.26-.51c-.14-.46-.41-.86-.8-1.2s-.82-.53-1.29-.57v-.99h-1.38v.99c-.66.14-1.17.43-1.54.87s-.55.92-.55 1.46c0 .62.18 1.12.54 1.5.36.38.93.71 1.71.99.83.3 1.4.57 1.73.81s.48.55.48.93c0 .43-.15.75-.46.96s-.68.31-1.11.31-.82-.13-1.15-.4-.58-.67-.74-1.21l-1.3.51c.18.63.47 1.14.86 1.53s.89.65 1.51.8v1.03Zm.71 3.67c-1.27 0-2.47-.24-3.59-.72s-2.09-1.14-2.92-1.97-1.48-1.8-1.97-2.92-.72-2.31-.72-3.59.24-2.47.72-3.59 1.14-2.09 1.97-2.92S7.29 4 8.41 3.51s2.31-.72 3.59-.72 2.47.24 3.59.72 2.09 1.14 2.92 1.97 1.48 1.8 1.97 2.92.72 2.31.72 3.59-.24 2.47-.72 3.59-1.14 2.09-1.97 2.92-1.8 1.48-2.92 1.97-2.31.72-3.59.72Zm0-1.67c2.1 0 3.88-.73 5.34-2.19s2.19-3.24 2.19-5.34-.73-3.88-2.19-5.34S14.1 4.46 12 4.46s-3.88.73-5.34 2.19-2.19 3.24-2.19 5.34.73 3.88 2.19 5.34S9.9 19.52 12 19.52Z"
  }),
  dollarFilled: /*#__PURE__*/React.createElement("path", {
    d: "M20.47 8.41c-.48-1.12-1.14-2.09-1.97-2.92s-1.8-1.48-2.92-1.97c-1.12-.48-2.31-.72-3.59-.72s-2.47.24-3.59.72C7.28 4 6.31 4.66 5.48 5.49S4 7.29 3.51 8.41c-.48 1.12-.72 2.31-.72 3.59s.24 2.47.72 3.59c.48 1.12 1.14 2.09 1.97 2.92s1.8 1.48 2.92 1.97c1.12.48 2.31.72 3.59.72s2.47-.24 3.59-.72c1.12-.48 2.09-1.14 2.92-1.97s1.48-1.8 1.97-2.92c.48-1.12.72-2.31.72-3.59s-.24-2.47-.72-3.59Zm-6.11 7.35c-.47.39-1.04.65-1.7.77v.99h-1.38v-1.03c-.62-.14-1.12-.41-1.51-.8s-.67-.9-.86-1.53l1.3-.51c.16.54.4.94.74 1.21.34.27.72.4 1.15.4s.81-.1 1.11-.31.46-.52.46-.96c0-.38-.16-.69-.48-.93-.32-.24-.9-.51-1.73-.81-.78-.28-1.34-.6-1.71-.99-.36-.38-.54-.88-.54-1.5 0-.54.18-1.03.55-1.46.37-.43.88-.72 1.54-.87v-.99h1.38v.99c.47.04.9.23 1.29.57s.65.74.8 1.2l-1.26.51c-.11-.3-.28-.56-.51-.76-.24-.2-.57-.31-.99-.31-.46 0-.81.1-1.05.3-.24.2-.36.47-.36.81s.15.61.45.81c.3.2.85.43 1.64.69.95.34 1.58.74 1.89 1.2.32.46.47.97.47 1.52 0 .78-.24 1.36-.71 1.75Z"
  }),
  dot: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "6"
  })),
  dotsHorizontal: /*#__PURE__*/React.createElement("path", {
    d: "M16,12A2,2 0 0,1 18,10A2,2 0 0,1 20,12A2,2 0 0,1 18,14A2,2 0 0,1 16,12M10,12A2,2 0 0,1 12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12M4,12A2,2 0 0,1 6,10A2,2 0 0,1 8,12A2,2 0 0,1 6,14A2,2 0 0,1 4,12Z"
  }),
  dotsVertical: /*#__PURE__*/React.createElement("path", {
    d: "M12,16A2,2 0 0,1 14,18A2,2 0 0,1 12,20A2,2 0 0,1 10,18A2,2 0 0,1 12,16M12,10A2,2 0 0,1 14,12A2,2 0 0,1 12,14A2,2 0 0,1 10,12A2,2 0 0,1 12,10M12,4A2,2 0 0,1 14,6A2,2 0 0,1 12,8A2,2 0 0,1 10,6A2,2 0 0,1 12,4Z"
  }),
  dragIndicator: /*#__PURE__*/React.createElement("path", {
    d: "M8.74778 20C8.26593 20 7.85417 19.8284 7.5125 19.4853C7.17083 19.1421 7 18.7296 7 18.2478C7 17.7659 7.17157 17.3542 7.51472 17.0125C7.85786 16.6708 8.27036 16.5 8.75222 16.5C9.23407 16.5 9.64583 16.6716 9.9875 17.0147C10.3292 17.3579 10.5 17.7704 10.5 18.2522C10.5 18.7341 10.3284 19.1458 9.98528 19.4875C9.64214 19.8292 9.22964 20 8.74778 20ZM15.2478 20C14.7659 20 14.3542 19.8284 14.0125 19.4853C13.6708 19.1421 13.5 18.7296 13.5 18.2478C13.5 17.7659 13.6716 17.3542 14.0147 17.0125C14.3579 16.6708 14.7704 16.5 15.2522 16.5C15.7341 16.5 16.1458 16.6716 16.4875 17.0147C16.8292 17.3579 17 17.7704 17 18.2522C17 18.7341 16.8284 19.1458 16.4853 19.4875C16.1421 19.8292 15.7296 20 15.2478 20ZM8.74778 13.75C8.26593 13.75 7.85417 13.5784 7.5125 13.2353C7.17083 12.8921 7 12.4796 7 11.9978C7 11.5159 7.17157 11.1042 7.51472 10.7625C7.85786 10.4208 8.27036 10.25 8.75222 10.25C9.23407 10.25 9.64583 10.4216 9.9875 10.7647C10.3292 11.1079 10.5 11.5204 10.5 12.0022C10.5 12.4841 10.3284 12.8958 9.98528 13.2375C9.64214 13.5792 9.22964 13.75 8.74778 13.75ZM15.2478 13.75C14.7659 13.75 14.3542 13.5784 14.0125 13.2353C13.6708 12.8921 13.5 12.4796 13.5 11.9978C13.5 11.5159 13.6716 11.1042 14.0147 10.7625C14.3579 10.4208 14.7704 10.25 15.2522 10.25C15.7341 10.25 16.1458 10.4216 16.4875 10.7647C16.8292 11.1079 17 11.5204 17 12.0022C17 12.4841 16.8284 12.8958 16.4853 13.2375C16.1421 13.5792 15.7296 13.75 15.2478 13.75ZM8.74778 7.5C8.26593 7.5 7.85417 7.32843 7.5125 6.98528C7.17083 6.64214 7 6.22964 7 5.74778C7 5.26593 7.17157 4.85417 7.51472 4.5125C7.85786 4.17083 8.27036 4 8.75222 4C9.23407 4 9.64583 4.17157 9.9875 4.51472C10.3292 4.85786 10.5 5.27036 10.5 5.75222C10.5 6.23407 10.3284 6.64583 9.98528 6.9875C9.64214 7.32917 9.22964 7.5 8.74778 7.5ZM15.2478 7.5C14.7659 7.5 14.3542 7.32843 14.0125 6.98528C13.6708 6.64214 13.5 6.22964 13.5 5.74778C13.5 5.26593 13.6716 4.85417 14.0147 4.5125C14.3579 4.17083 14.7704 4 15.2522 4C15.7341 4 16.1458 4.17157 16.4875 4.51472C16.8292 4.85786 17 5.27036 17 5.75222C17 6.23407 16.8284 6.64583 16.4853 6.9875C16.1421 7.32917 15.7296 7.5 15.2478 7.5Z"
  }),
  editNote: /*#__PURE__*/React.createElement("path", {
    d: "M3,10h11v2H3V10z M3,8h11V6H3V8z M3,16h7v-2H3V16z M18.01,12.87l0.71-0.71c0.39-0.39,1.02-0.39,1.41,0l0.71,0.71 c0.39,0.39,0.39,1.02,0,1.41l-0.71,0.71L18.01,12.87z M17.3,13.58l-5.3,5.3V21h2.12l5.3-5.3L17.3,13.58z"
  }),
  editPencil: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })),
  email: /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
  }),
  emailOutlined: /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
  }),
  error: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
  }),
  errorOutline: /*#__PURE__*/React.createElement("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  }),
  expandLeft: /*#__PURE__*/React.createElement("path", {
    d: "M10.891,20 L21.558,20 L21.558,18.222 L10.891,18.222 L10.891,20 Z M2.891,12.889 L2.891,12.877 L2,11.987 L5.771,8.216 L7.028,9.473 L5.39,11.111 L21.558,11.111 L21.558,12.889 L5.417,12.889 L7.077,14.549 L5.82,15.806 L3.257,13.243 L3.257,13.244 L2.902,12.889 L2.891,12.889 Z M10.891,5.778 L21.558,5.778 L21.558,4 L10.891,4 L10.891,5.778 Z"
  }),
  expandRight: /*#__PURE__*/React.createElement("path", {
    d: "M2,20 L12.667,20 L12.667,18.222 L2,18.222 L2,20 Z M20.655,12.889 L20.3,13.244 L20.3,13.243 L17.737,15.806 L16.48,14.549 L18.14,12.889 L2,12.889 L2,11.111 L18.167,11.111 L16.529,9.473 L17.786,8.216 L21.558,11.987 L20.667,12.877 L20.667,12.889 L20.655,12.889 Z M2,5.778 L12.667,5.778 L12.667,4 L2,4 L2,5.778 Z"
  }),
  fastForward: /*#__PURE__*/React.createElement("path", {
    d: "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
  }),
  fastRewind: /*#__PURE__*/React.createElement("path", {
    d: "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
  }),
  favorite: /*#__PURE__*/React.createElement("path", {
    d: "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
  }),
  favoriteBorder: /*#__PURE__*/React.createElement("path", {
    d: "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
  }),
  feed: /*#__PURE__*/React.createElement("path", {
    d: "M16,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V8L16,3z M7,7h5v2H7V7z M17,17H7v-2h10V17z M17,13H7v-2h10 V13z M15,9V5l4,4H15z"
  }),
  fileDownload: /*#__PURE__*/React.createElement("path", {
    d: "M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M17,11l-1.41-1.41L13,12.17V4h-2v8.17L8.41,9.59L7,11l5,5 L17,11z"
  }),
  filter: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18h2c.55 0 1-.45 1-1s-.45-1-1-1h-2c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1zm4 6h10c.55 0 1-.45 1-1s-.45-1-1-1H7c-.55 0-1 .45-1 1s.45 1 1 1z"
  })),
  flag: /*#__PURE__*/React.createElement("path", {
    d: "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
  }),
  follows: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,12c-2.21,0-4-1.79-4-4s1.79-4,4-4,4,1.79,4,4-1.79,4-4,4ZM12,5.5c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5,2.5-1.12,2.5-2.5-1.12-2.5-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.25,20h-5.3c-.91,0-1.73-.45-2.14-1.17-.36-.63-.35-1.37.04-2.02.96-1.63,3.03-3.56,7.4-3.56.41,0,.75.34.75.75s-.34.75-.75.75c-3.67,0-5.35,1.54-6.11,2.83-.11.18-.12.35-.03.51.12.21.42.41.84.41h5.3c.41,0,.75.34.75.75s-.34.75-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,20c-.22,0-.43-.1-.58-.27l-1.25-1.5c-.27-.32-.22-.79.1-1.06.32-.27.79-.22,1.06.1l.63.76,2.68-3.72c.24-.33.71-.41,1.05-.17s.41.71.17,1.05l-3.25,4.5c-.14.19-.35.3-.58.31,0,0-.03,0-.03,0Z"
  })),
  followsFilled: /*#__PURE__*/React.createElement("path", {
    d: "M12 12c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4Zm0-6.13c-1.18 0-2.13.95-2.13 2.13s.95 2.13 2.13 2.13 2.13-.95 2.13-2.13-.95-2.13-2.13-2.13Zm.23 12.31a.71.71 0 0 0-.35-.1H6.79c-.41 0-.71-.18-.81-.38-.11-.23.08-.55.23-.79.72-1.1 2.6-2.28 5.66-2.14h.06a1.071 1.071 0 0 0 0-2.14c-.02 0-.03 0-.05.01-.03 0-.06-.02-.09-.02-4.64 0-6.83 2.23-7.85 4.11-.41.75-.42 1.44-.04 2.17.44.83 1.3 1.35 2.27 1.35h5.76c.59 0 1.07-.48 1.07-1.07 0-.49-.33-.88-.77-1.01ZM16 20c-.22 0-.43-.1-.58-.27l-1.25-1.5a.75.75 0 0 1 .1-1.06.75.75 0 0 1 1.06.1l.63.76 2.68-3.72a.751.751 0 1 1 1.22.88l-3.25 4.5c-.14.19-.35.3-.58.31H16Z"
  }),
  fontDownload: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
  })),
  fullscreen: /*#__PURE__*/React.createElement("path", {
    d: "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
  }),
  fullscreenExit: /*#__PURE__*/React.createElement("path", {
    d: "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
  }),
  gift: /*#__PURE__*/React.createElement("path", {
    d: "M10.8,14.4 L10.8,24 L2.4,24 C1.7372583,24 1.2,23.4627417 1.2,22.8 L1.2,14.4 L10.8,14.4 Z M22.8,14.4 L22.8,22.8 C22.8,23.4627417 22.2627417,24 21.6,24 L13.2,24 L13.2,14.4 L22.8,14.4 Z M22.8,7.2 C23.4627417,7.2 24,7.7372583 24,8.4 L24,10.8 C24,11.4627417 23.4627417,12 22.8,12 L13.2,12 L13.2,7.2 L22.8,7.2 Z M10.8,7.2 L10.8,12 L1.2,12 C0.5372583,12 0,11.4627417 0,10.8 L0,8.4 C0,7.7372583 0.5372583,7.2 1.2,7.2 L10.8,7.2 Z M11.1,6.6 L11.0994694,6.59090632 C7.91559659,6.52404579 5.91341321,6.08438726 4.9796039,5.1363961 C3.13627163,3.29306384 3.63023121,0 6.516,0 C8.28667415,0 10.6649338,1.40637406 11.8234858,2.88710496 C13.0360859,1.40317104 15.5364983,0 17.388,0 C20.377194,0 20.9062262,3.30645127 18.9655984,5.15465429 C17.8905412,6.16885913 15.6098061,6.6 12,6.6 L12,6.6 L11.1,6.6 Z M17.388,1.8 C15.7379252,1.8 12.9,3.79012989 12.9,4.5 L12.9,4.5 L12.9,4.788 L13.496024,4.7691931 C15.6646957,4.67433355 17.0678144,4.36587318 17.6431432,3.92000817 L17.6431432,3.92000817 L17.7273103,3.84827586 C18.642997,2.97619336 18.454806,1.8 17.388,1.8 Z M6.516,1.8 C5.56176879,1.8 5.38268489,2.99389268 6.25716291,3.86840668 C6.72360857,4.3419197 8.1839747,4.67726309 10.5500121,4.77245105 L10.5500121,4.77245105 L10.7196,4.7784 L10.716,4.5 C10.716,3.77669312 8.04746429,1.8 6.516,1.8 Z"
  }),
  goldCoin: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.87,21a8.54,8.54,0,0,0,2.93-1c-4.49,1.72-8.7-3-10.23-6.74C3.18,9.91,2.65,4.68,6.31,2.5c-2,1.16-3.48,2.27-4,4.6a11.15,11.15,0,0,0,.42,6.18C3.93,17,7.52,21.43,11.87,21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17,8.19c1.34,2.76,2,6.51.29,9.28-1.85,3-5.56,2.62-8.1.73A12.69,12.69,0,0,1,4.36,9.86C4,7,4.76,3.25,7.94,2.35,11.84,1.25,15.49,5,17,8.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.47,4.83a5.42,5.42,0,0,1,1-2.66h0a5.46,5.46,0,0,1-1,2.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.33,6.32c.57-1,1.89-1.46,2.86-2h0C19.38,5.09,18.45,6.14,17.33,6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.93,7.77c.86-.42,2,0,2.89.17V8c-.9.08-2.09.34-2.89-.17Z"
  })),
  graphicEq: /*#__PURE__*/React.createElement("path", {
    d: "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
  }),
  gridLarge: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "10",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "0",
    width: "10",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "12",
    width: "10",
    height: "10"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "12",
    width: "10",
    height: "10"
  })),
  gridMedium: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "0",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16",
    y: "0",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "8",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "16",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "8",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16",
    y: "8",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "8",
    y: "16",
    width: "6",
    height: "6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "16",
    y: "16",
    width: "6",
    height: "6"
  })),
  gridSmall: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "0",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "0",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "18",
    y: "0",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "6",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "6",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "18",
    y: "6",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "18",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "6",
    y: "18",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "0",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "6",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "12",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "0",
    y: "18",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "12",
    y: "18",
    width: "4",
    height: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: "18",
    y: "18",
    width: "4",
    height: "4"
  })),
  group: /*#__PURE__*/React.createElement("path", {
    d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
  }),
  hangouts: /*#__PURE__*/React.createElement("path", {
    d: "M15,11L14,13H12.5L13.5,11H12V8H15M11,11L10,13H8.5L9.5,11H8V8H11M11.5,2A8.5,8.5 0 0,0 3,10.5A8.5,8.5 0 0,0 11.5,19H12V22.5C16.86,20.15 20,15 20,10.5C20,5.8 16.19,2 11.5,2Z"
  }),
  headsetMic: /*#__PURE__*/React.createElement("path", {
    d: "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"
  }),
  help: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
  }),
  history: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
  })),
  home: /*#__PURE__*/React.createElement("path", {
    d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
  }),
  homeOutlined: /*#__PURE__*/React.createElement("path", {
    d: "M12 5.69l5 4.5V18h-2v-6H9v6H7v-7.81l5-4.5M12 3L2 12h3v8h6v-6h2v6h6v-8h3L12 3z"
  }),
  idCard: /*#__PURE__*/React.createElement("path", {
    d: "M 14 13 L 19 13 L 19 11 L 14 11 Z M 14 10 L 19 10 L 19 8 L 14 8 Z M 5 16 L 13 16 L 13 15.449219 C 13 14.699219 12.632812 14.105469 11.898438 13.664062 C 11.167969 13.222656 10.199219 13 9 13 C 7.800781 13 6.832031 13.222656 6.101562 13.664062 C 5.367188 14.105469 5 14.699219 5 15.449219 Z M 9 12 C 9.550781 12 10.019531 11.804688 10.414062 11.414062 C 10.804688 11.019531 11 10.550781 11 10 C 11 9.449219 10.804688 8.980469 10.414062 8.585938 C 10.019531 8.195312 9.550781 8 9 8 C 8.449219 8 7.980469 8.195312 7.585938 8.585938 C 7.195312 8.980469 7 9.449219 7 10 C 7 10.550781 7.195312 11.019531 7.585938 11.414062 C 7.980469 11.804688 8.449219 12 9 12 Z M 4 20 C 3.449219 20 2.980469 19.804688 2.585938 19.414062 C 2.195312 19.019531 2 18.550781 2 18 L 2 6 C 2 5.449219 2.195312 4.980469 2.585938 4.585938 C 2.980469 4.195312 3.449219 4 4 4 L 20 4 C 20.550781 4 21.019531 4.195312 21.414062 4.585938 C 21.804688 4.980469 22 5.449219 22 6 L 22 18 C 22 18.550781 21.804688 19.019531 21.414062 19.414062 C 21.019531 19.804688 20.550781 20 20 20 Z M 4 18 L 20 18 L 20 6 L 4 6 Z M 4 18 L 4 6 Z M 4 18 "
  }),
  imageLibrary: /*#__PURE__*/React.createElement("path", {
    d: "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4 2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
  }),
  info: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
  }),
  insertEmoticon: /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
  }),
  keyboardArrowDown: /*#__PURE__*/React.createElement("path", {
    d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
  }),
  keyboardArrowUp: /*#__PURE__*/React.createElement("path", {
    d: "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
  }),
  language: /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
  }),
  listView: /*#__PURE__*/React.createElement("path", {
    d: "M3 14h4v-4H3v4zm0 5h4v-4H3v4zM3 9h4V5H3v4zm5 5h13v-4H8v4zm0 5h13v-4H8v4zM8 5v4h13V5H8z"
  }),
  liveHelp: /*#__PURE__*/React.createElement("path", {
    d: "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
  }),
  liveNowCam: /*#__PURE__*/React.createElement("path", {
    d: "M21.6,0 L2.4,0 C1.08,0 0,1.08 0,2.4 L0,24 L4.8,19.2 L21.6,19.2 C22.92,19.2 24,18.12 24,16.8 L24,2.4 C24,1.08 22.92,0 21.6,0 L21.6,0 Z M19,15 L14.3333334,11 L14.3333334,15 L5,15 L5,5 L14.3333334,5 L14.3333334,9 L19,5 L19,15 L19,15 Z"
  }),
  lock: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0V0z",
    opacity: ".87"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  })),
  lockOpen: /*#__PURE__*/React.createElement("path", {
    d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h2c0-1.66 1.34-3 3-3s3 1.34 3 3v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2z"
  }),
  lockReset: /*#__PURE__*/React.createElement("path", {
    d: "M12.63,2C18.16,2 22.64,6.5 22.64,12C22.64,17.5 18.16,22 12.63,22C9.12,22 6.05,20.18 4.26,17.43L5.84,16.18C7.25,18.47 9.76,20 12.64,20A8,8 0 0,0 20.64,12A8,8 0 0,0 12.64,4C8.56,4 5.2,7.06 4.71,11H7.47L3.73,14.73L0,11H2.69C3.19,5.95 7.45,2 12.63,2M15.59,10.24C16.09,10.25 16.5,10.65 16.5,11.16V15.77C16.5,16.27 16.09,16.69 15.58,16.69H10.05C9.54,16.69 9.13,16.27 9.13,15.77V11.16C9.13,10.65 9.54,10.25 10.04,10.24V9.23C10.04,7.7 11.29,6.46 12.81,6.46C14.34,6.46 15.59,7.7 15.59,9.23V10.24M12.81,7.86C12.06,7.86 11.44,8.47 11.44,9.23V10.24H14.19V9.23C14.19,8.47 13.57,7.86 12.81,7.86Z"
  }),
  login: /*#__PURE__*/React.createElement("path", {
    d: "M11,7L9.6,8.4l2.6,2.6H2v2h10.2l-2.6,2.6L11,17l5-5L11,7z M20,19h-8v2h8c1.1,0,2-0.9,2-2V5c0-1.1-0.9-2-2-2h-8v2h8V19z"
  }),
  logout: /*#__PURE__*/React.createElement("path", {
    d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"
  }),
  loyaltyTag: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
  })),
  menu: /*#__PURE__*/React.createElement("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
  }),
  mic: /*#__PURE__*/React.createElement("path", {
    d: "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
  }),
  micOff: /*#__PURE__*/React.createElement("path", {
    d: "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
  }),
  minusCircle: /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
  }),
  more: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12,3.92C7.55,3.92,3.92,7.55,3.92,12s3.63,8.08,8.08,8.08,8.08-3.63,8.08-8.08S16.45,3.92,12,3.92ZM12,18.43c-3.55,0-6.43-2.88-6.43-6.43s2.88-6.43,6.43-6.43,6.43,2.88,6.43,6.43-2.88,6.43-6.43,6.43Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "1.1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "8.7",
    cy: "12",
    r: "1.1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "15.3",
    cy: "12",
    r: "1.1"
  })),
  moreFilled: /*#__PURE__*/React.createElement("path", {
    d: "M12,3.92C7.54,3.92,3.92,7.54,3.92,12s3.63,8.09,8.08,8.09,8.09-3.63,8.09-8.09S16.46,3.92,12,3.92ZM8.7,13.1c-.61,0-1.1-.49-1.1-1.1s.49-1.1,1.1-1.1,1.1.49,1.1,1.1-.49,1.1-1.1,1.1ZM12,13.1c-.61,0-1.1-.49-1.1-1.1s.49-1.1,1.1-1.1,1.1.49,1.1,1.1-.49,1.1-1.1,1.1ZM15.3,13.1c-.61,0-1.1-.49-1.1-1.1s.49-1.1,1.1-1.1,1.1.49,1.1,1.1-.49,1.1-1.1,1.1Z"
  }),
  multilineChart: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })),
  newsletter: /*#__PURE__*/React.createElement("path", {
    d: "M22,3l-1.67,1.67L18.67,3L17,4.67L15.33,3l-1.66,1.67L12,3l-1.67,1.67L8.67,3L7,4.67L5.33,3L3.67,4.67L2,3v16 c0,1.1,0.9,2,2,2l16,0c1.1,0,2-0.9,2-2V3z M11,19H4v-6h7V19z M20,19h-7v-2h7V19z M20,15h-7v-2h7V15z M20,11H4V8h16V11z"
  }),
  notepadPencil: /*#__PURE__*/React.createElement("path", {
    d: "M15 20c2.26 0 4-1.74 4-4v-2c0-.626-.108-.774 0-1-.432.09-.607.118-1 0l-1 1c.313.197.273.305 0 0v2c.273 1.301-.699 2.273-2 2H4c-1.301.273-2.273-.699-2-2V5c-.273-1.301.699-2.273 2-2h11c.316-.273.518-.246 1 0-.13-.138.031-.178 0 0l1-1c-.078-.069-.038-.204 0 0-.092-.487-.186-.609 0-1-.807.108-1.347 0-2 0H4C1.74 1 0 2.74 0 5v11c0 2.26 1.74 4 4 4h11zm8-13l1-1c.113-.898.113-1.81 0-2l-2-3c-.658-.136-1.418-.136-2 0l-1 2 4 4zM13 17l9-9-4-4-9 9v4h4zm0-7c-.034-.193-.022-.382 0 0l5-5c-.382-.022-.193-.034 0 0 .034.193.022.382 0 0l-5 5c.382.022.193.034 0 0zm-1 6h-1v-1h-1v-1l2-2 2 2-2 2z"
  }),
  notifications: /*#__PURE__*/React.createElement("path", {
    d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
  }),
  notificationsActive: /*#__PURE__*/React.createElement("path", {
    d: "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
  }),
  openInNew: /*#__PURE__*/React.createElement("path", {
    d: "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
  }),
  paintBrush: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
  })),
  palette: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })),
  pause: /*#__PURE__*/React.createElement("path", {
    d: "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
  }),
  person: /*#__PURE__*/React.createElement("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
  }),
  phone: /*#__PURE__*/React.createElement("path", {
    d: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
  }),
  phoneInTalk: /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"
  }),
  photoCamera: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
  })),
  play: /*#__PURE__*/React.createElement("path", {
    d: "M8 5v14l11-7z"
  }),
  playCircle: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "8",
    fill: "rgba(0,0,0,0.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  })),
  playCircleClear: /*#__PURE__*/React.createElement("path", {
    d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
  }),
  printer: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
  })),
  pulse: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 4H4a2 2 0 00-2 2v3h2V6h16v3h2V6a2 2 0 00-2-2zM20 18H4v-3H2v3c0 1.1.9 2 2 2h16a2 2 0 002-2v-3h-2v3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.89 7.55c-.34-.68-1.45-.68-1.79 0L10 13.76l-1.11-2.21A.99.99 0 008 11H2v2h5.38l1.72 3.45c.18.34.52.55.9.55s.72-.21.89-.55L14 10.24l1.11 2.21c.17.34.51.55.89.55h6v-2h-5.38l-1.73-3.45z"
  })),
  receipt: /*#__PURE__*/React.createElement("path", {
    d: "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
  }),
  refresh: /*#__PURE__*/React.createElement("path", {
    d: "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
  }),
  reply: /*#__PURE__*/React.createElement("path", {
    d: "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
  }),
  report: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })),
  rewards: /*#__PURE__*/React.createElement("path", {
    d: "M6.3,15.72l4.47,2.49L8.68,23.42,6.55,21.49H3.63Zm11.39,0,2.68,5.78H17.45l-2.13,1.93L13.23,18.2l4.47-2.49ZM12,.58l7.54,4.28v8.56L12,17.71,4.47,13.43V4.87Z"
  }),
  rssfeed: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: "6.18",
    cy: "17.82",
    r: "2.18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
  })),
  save: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
  })),
  search: /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14\n5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
  }),
  searchFilled: /*#__PURE__*/React.createElement("path", {
    d: "M19.3 20.59c-.33 0-.66-.12-.91-.38l-3.7-3.7a7.116 7.116 0 0 1-4.09 1.28c-4.05-.12-7.19-3.28-7.19-7.19s3.22-7.19 7.19-7.19 7.19 3.22 7.19 7.19c0 1.52-.47 2.93-1.28 4.09l3.7 3.7a1.292 1.292 0 0 1-.91 2.2Zm-8.7-14.6c-2.54 0-4.61 2.07-4.61 4.61s2.04 4.53 4.65 4.61c2.5 0 4.57-2.07 4.57-4.61s-2.07-4.61-4.61-4.61Z"
  }),
  send: /*#__PURE__*/React.createElement("path", {
    d: "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
  }),
  settings: /*#__PURE__*/React.createElement("path", {
    d: "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
  }),
  share: /*#__PURE__*/React.createElement("path", {
    d: "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
  }),
  shareLink: /*#__PURE__*/React.createElement("path", {
    d: "M14.4 14.4292V19.1688L24 11.0708L14.4 3V7.60417C5.07 8.76875 1.35 14.5375 0 20.3333C3.33 16.2708 7.74 14.4292 14.4 14.4292Z"
  }),
  shoppingCart: /*#__PURE__*/React.createElement("path", {
    d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
  }),
  skipNext: /*#__PURE__*/React.createElement("path", {
    d: "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
  }),
  skipPrevious: /*#__PURE__*/React.createElement("path", {
    d: "M6 6h2v12H6zm3.5 6l8.5 6V6z"
  }),
  smartphone: /*#__PURE__*/React.createElement("path", {
    d: "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
  }),
  smsTextMessage: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"
  })),
  spendingLimit: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,8 L7,20.5 L4,20.5 L4,8 L2.5,8 L5.5,4 L8.5,8 L7,8 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.5 13 9.5 13 9.5 16 17.5 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "14.5 17.5 9.5 17.5 9.5 20.5 14.5 20.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "19.5 8.5 9.5 8.5 9.5 11.5 19.5 11.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.5 4 9.5 4 9.5 7 22.5 7"
  })),
  star: /*#__PURE__*/React.createElement("path", {
    d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
  }),
  starBorder: /*#__PURE__*/React.createElement("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
  }),
  starHalf: /*#__PURE__*/React.createElement("path", {
    d: "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
  }),
  stars: /*#__PURE__*/React.createElement("path", {
    d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
  }),
  start: /*#__PURE__*/React.createElement("path", {
    d: "M14.59,7.41L18.17,11H6v2h12.17l-3.59,3.59L16,18l6-6l-6-6L14.59,7.41z M2,6v12h2V6H2z"
  }),
  stop: /*#__PURE__*/React.createElement("path", {
    d: "M4 4h16v16H4z"
  }),
  subdirectoryArrowRight: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
  })),
  subscriptions: /*#__PURE__*/React.createElement("path", {
    d: "M18.2309 3C18.3967 2.99999 18.5559 3.06538 18.6738 3.18197C18.7918 3.29857 18.859 3.45697 18.8609 3.6228V20.3772C18.859 20.543 18.7918 20.7014 18.6738 20.818C18.5559 20.9346 18.3967 21 18.2309 21C18.0858 21.0005 17.945 20.9509 17.8322 20.8596L11.9309 16.0842L6.0287 20.8596C5.89875 20.9641 5.73289 21.0132 5.56699 20.9964C5.40109 20.9795 5.24849 20.8981 5.1422 20.7696C5.05029 20.6588 4.99999 20.5194 5 20.3754V3.6228C5.0019 3.45681 5.06923 3.29827 5.18737 3.18165C5.30551 3.06503 5.4649 2.99975 5.6309 3H18.2309ZM11.9309 6.1149L10.8977 8.5026L8.2733 8.7285L10.2668 10.4286L9.6449 12.9693L11.9309 11.622L14.171 12.972L13.577 10.4313L15.5885 8.7312L12.9461 8.5053L11.9309 6.1149Z"
  }),
  subscriptionsFilled: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8 6h8v7H8V6Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23 3a.63.63 0 0 1 .63.623v16.754a.63.63 0 0 1-1.028.483l-5.901-4.776-5.902 4.776a.635.635 0 0 1-.887-.09.617.617 0 0 1-.142-.395V3.623A.63.63 0 0 1 5.63 3h12.6Zm-6.3 3.115-1.032 2.388-2.625.226 1.994 1.7-.622 2.54 2.286-1.347 2.24 1.35-.594-2.54 2.011-1.7-2.642-.227-1.015-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.23 3a.63.63 0 0 1 .63.623v16.754a.63.63 0 0 1-1.028.483l-5.901-4.776-5.902 4.776a.635.635 0 0 1-.887-.09.617.617 0 0 1-.142-.395V3.623A.63.63 0 0 1 5.63 3h12.6Zm-6.3 3.115-1.032 2.388-2.625.226 1.994 1.7-.622 2.54 2.286-1.347 2.24 1.35-.594-2.54 2.011-1.7-2.642-.227-1.015-2.39Z"
  })),
  subtract: /*#__PURE__*/React.createElement("path", {
    d: "M19 13H5v-2h14v2z"
  }),
  sync: /*#__PURE__*/React.createElement("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
  }),
  tag: /*#__PURE__*/React.createElement("path", {
    d: "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
  }),
  tapAndPlay: /*#__PURE__*/React.createElement("path", {
    d: "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
  }),
  textFormatClear: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
  })),
  textFormatColor: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20h24v4H0z",
    fillOpacity: ".36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
  })),
  textFormatSize: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
  })),
  thumbUp: /*#__PURE__*/React.createElement("path", {
    d: "M2 20h2c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1H2v11zm19.83-7.12c.11-.25.17-.52.17-.8V11c0-1.1-.9-2-2-2h-5.5l.92-4.65c.05-.22.02-.46-.08-.66-.23-.45-.52-.86-.88-1.22L14 2 7.59 8.41C7.21 8.79 7 9.3 7 9.83v7.84C7 18.95 8.05 20 9.34 20h8.11c.7 0 1.36-.37 1.72-.97l2.66-6.15z"
  }),
  timer: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
  })),
  trophy: /*#__PURE__*/React.createElement("path", {
    d: "M20.2,4H20H17V2H7V4H4.5H3.8H2V11C2,12 3,13 4,13H7.2C7.6,14.9 8.6,16.6 11,16.9V19C8,19.2 8,20.3 8,21.6V22H16V21.7C16,20.4 16,19.3 13,19.1V17C15.5,16.7 16.5,15 16.8,13.1H20C21,13.1 22,12.1 22,11.1V4H20.2M4,11V6H7V8V11C5.6,11 4.4,11 4,11M20,11C19.6,11 18.4,11 17,11V6H18H20V11Z"
  }),
  upload: /*#__PURE__*/React.createElement("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4 0-2.05 1.53-3.76 3.56-3.97l1.07-.11.5-.95C8.08 7.14 9.94 6 12 6c2.62 0 4.88 1.86 5.39 4.43l.3 1.5 1.53.11c1.56.1 2.78 1.41 2.78 2.96 0 1.65-1.35 3-3 3zM8 13h2.55v3h2.9v-3H16l-4-4z"
  }),
  verified: /*#__PURE__*/React.createElement("path", {
    d: "M23,12l-2.44-2.79l0.34-3.69l-3.61-0.82L15.4,1.5L12,2.96L8.6,1.5L6.71,4.69L3.1,5.5L3.44,9.2L1,12l2.44,2.79l-0.34,3.7 l3.61,0.82L8.6,22.5l3.4-1.47l3.4,1.46l1.89-3.19l3.61-0.82l-0.34-3.69L23,12z M10.09,16.72l-3.8-3.81l1.48-1.48l2.32,2.33 l5.85-5.87l1.48,1.48L10.09,16.72z"
  }),
  verifiedUser: /*#__PURE__*/React.createElement("path", {
    d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
  }),
  video: /*#__PURE__*/React.createElement("path", {
    d: "M18.111 10V5.333C18.111 4.6 17.561 4 16.89 4H2.222C1.55 4 1 4.6 1 5.333v13.334C1 19.4 1.55 20 2.222 20H16.89c.672 0 1.222-.6 1.222-1.333V14l2.799 3.053c.77.84 2.09.24 2.09-.946V7.88c0-1.187-1.32-1.787-2.09-.947L18.111 10Z"
  }),
  videoBigger: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.6381546,14.7515808 L10.9672157,17.0806419 L10.9672157,11.0806419 L4.96721573,11.0806419 L7.22394104,13.3373672 L4,16.5613083 L5.41421356,17.9755219 L8.6381546,14.7515808z",
    transform: "translate(7.483608, 14.528082) rotate(-180.000000) translate(-7.483608, -14.528082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7188194,7.67093887 L18.0478806,10 L18.0478806,4 L12.0478806,4 L14.3046059,6.25672531 L11.0806648,9.48066635 L12.4948784,10.8948799 L15.7188194,7.67093887z"
  })),
  videocam: /*#__PURE__*/React.createElement("path", {
    d: "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
  }),
  videocamOff: /*#__PURE__*/React.createElement("path", {
    d: "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
  }),
  videoLibrary: /*#__PURE__*/React.createElement("path", {
    d: "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
  }),
  videoLibraryClapper: /*#__PURE__*/React.createElement("path", {
    d: "M0,8.86330935 L0,19.8105516 C0,21.0256954 1.03273381,22 2.29496403,22 L20.6546763,22 C21.9283813,22 22.9496403,21.0256954 22.9496403,19.8105516 L22.9496403,8.86330935 L0,8.86330935 Z M3.15228987,3.95683453 L1.95879338,4.1639968 C0.641075821,4.39950759 -0.21385738,5.54653237 0.0467632822,6.72626699 L0.521726172,8.86330935 L6.48920863,7.80569145 L3.15228987,3.95683453 L3.15228987,3.95683453 Z M7.51412119,2.8179482 L5.0647482,3.29880335 L8.48392369,7.43884892 L12.6618705,6.69587602 L9.25512838,2.5323741 L7.51412119,2.8179482 Z M13.3702363,1.54254908 L10.9208633,1.98745147 L14.3400388,6.01438849 L18.5179856,5.29312407 L15.1112435,1.26618705 L13.3702363,1.54254908 Z M9.81294964,12.1870504 L13.7697842,15.4316547 L9.81294964,18.676259 L9.81294964,12.1870504 Z M21.1874628,0 L22,4.4521716 L19.9478226,4.90647482 L16.7769784,0.949640288 L21.1874628,0 Z"
  }),
  videoLibraryClapperFilled: /*#__PURE__*/React.createElement("path", {
    d: "M17.587 2.013H6.413A4.415 4.415 0 0 0 2 6.426v11.175a4.415 4.415 0 0 0 4.413 4.413h11.174c2.43 0 4.413-1.97 4.413-4.413V6.412A4.414 4.414 0 0 0 17.587 2v.013ZM4.037 7.425V6.413A2.377 2.377 0 0 1 6.36 4.038l2.335 3.387H4.038Zm8.138-3.387 2.335 3.4h-3.374l-2.334-3.4h3.373Zm2.578 10.769-3.765 2.564c-.176.162-.527.203-.702.04 0 0-.08-.107-.08-.161v-5.466l.08-.162c.175-.162.526-.108.715.04l3.766 2.565a.37.37 0 0 1 0 .566l-.014.014Zm5.21-7.382h-2.997l-2.334-3.4h2.941a2.393 2.393 0 0 1 2.39 2.388v1.012Z"
  }),
  videoSmaller: /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.4059816,7.02979319 L18.7352541,9.38350261 L18.7352541,3.29202596 L12.7070211,3.29202596 L14.977699,5.58652614 L12,8.56422518 L13.4357748,10 L16.4059816,7.02979319z",
    transform: "translate(15.367627, 6.646013) rotate(-180.000000) translate(-15.367627, -6.646013) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67072752,15.7377672 L10,18.0914767 L10,12 L3.97176697,12 L6.24244493,14.2945002 L3.26474589,17.2721992 L4.70052071,18.707974 L7.67072752,15.7377672z"
  })),
  viewComfy: /*#__PURE__*/React.createElement("path", {
    d: "M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"
  }),
  viewModule: /*#__PURE__*/React.createElement("path", {
    d: "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
  }),
  viewStream: /*#__PURE__*/React.createElement("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
  }),
  visibility: /*#__PURE__*/React.createElement("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z"
  }),
  visibilityOff: /*#__PURE__*/React.createElement("path", {
    d: "M12 6c3.79 0 7.17 2.13 8.82 5.5-.59 1.22-1.42 2.27-2.41 3.12l1.41 1.41c1.39-1.23 2.49-2.77 3.18-4.53C21.27 7.11 17 4 12 4c-1.27 0-2.49.2-3.64.57l1.65 1.65C10.66 6.09 11.32 6 12 6zm-1.07 1.14L13 9.21c.57.25 1.03.71 1.28 1.28l2.07 2.07c.08-.34.14-.7.14-1.07C16.5 9.01 14.48 7 12 7c-.37 0-.72.05-1.07.14zM2.01 3.87l2.68 2.68C3.06 7.83 1.77 9.53 1 11.5 2.73 15.89 7 19 12 19c1.52 0 2.98-.29 4.32-.82l3.42 3.42 1.41-1.41L3.42 2.45 2.01 3.87zm7.5 7.5l2.61 2.61c-.04.01-.08.02-.12.02-1.38 0-2.5-1.12-2.5-2.5 0-.05.01-.08.01-.13zm-3.4-3.4l1.75 1.75c-.23.55-.36 1.15-.36 1.78 0 2.48 2.02 4.5 4.5 4.5.63 0 1.23-.13 1.77-.36l.98.98c-.88.24-1.8.38-2.75.38-3.79 0-7.17-2.13-8.82-5.5.7-1.43 1.72-2.61 2.93-3.53z"
  }),
  volumeDown: /*#__PURE__*/React.createElement("path", {
    d: "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
  }),
  volumeMute: /*#__PURE__*/React.createElement("path", {
    d: "M7 9v6h4l5 5V4l-5 5H7z"
  }),
  volumeOff: /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
  }),
  volumeUp: /*#__PURE__*/React.createElement("path", {
    d: "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
  }),
  warning: /*#__PURE__*/React.createElement("path", {
    d: "M4.47 21h15.06c1.54 0 2.5-1.67 1.73-3L13.73 4.99c-.77-1.33-2.69-1.33-3.46 0L2.74 18c-.77 1.33.19 3 1.73 3zM12 14c-.55 0-1-.45-1-1v-2c0-.55.45-1 1-1s1 .45 1 1v2c0 .55-.45 1-1 1zm1 4h-2v-2h2v2z"
  }),
  // NOTE: this is an alias, so that same svg path can be returned when using "success" name as "checkCircle"
  get success() {
    return this.checkCircle;
  },
  get beenHere() {
    return this.discount;
  }
};
var _default = exports.default = SvgIconsMap;